<template>
  <div class="Container" v-if="UserProfile === 'SUP'">
    <h2 class="ViewHeading">Installer User Admin</h2>

    <b-container>
      <h5 class="pageHeader">Select User Admin Action</h5>

      <div class="tab">
        <button
          v-if="selectedAction != 'AddClient'"
          class="reportTabLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add Installer User
        </button>
        <button
          v-if="selectedAction == 'AddClient'"
          class="reportTabActiveLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add Installer User
        </button>
        <!--   <button   v-if="selectedAction != 'DeactClient'" class="reportTabRight" v-on:click="selectedAction = 'DeactClient', showModal('InstallerDeactivateModal')">Edit Installer User</button>
              <button   v-if="selectedAction == 'DeactClient'"  class="reportTabActiveRight" v-on:click="selectedAction = 'DeactClient',showModal('ClientDeactivateModal')">Edit Installer User</button> -->
        <button
          v-if="selectedAction != 'DeactInstaller'"
          class="reportTabRight"
          v-on:click="showModal('InstallerDeactivateModal')"
        >
          Remove Installer User
        </button>
        <button
          v-if="selectedAction == 'DeactInstaller'"
          class="reportTabActiveRight"
          v-on:click="selectedAction = 'DeactInstaller'"
        >
          Remove Installer User
        </button>
      </div>

      <div class="tabcontent">
        <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
                <h3>Installer Add Form</h3>

                <b-row>
                  <b-col sm="3">
                    <p id="FormText">First Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="First Name"
                      v-model="insFName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Last Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Last Name"
                      v-model="insLName"
                      required
                      v-on:blur="generateUserName()"
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Company</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="insCompany">
                      <option value="" select disabled>Select Company</option>
                      <option
                        v-for="(value, id) in this.companyArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.name }"
                        >{{ value.name }}</option
                      >
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">
                      Account Username <br />
                      Auto Generated
                    </p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="UserName"
                      v-model="nickname"
                      required
                      readonly
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Account Password</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Password"
                      v-model="insPassword"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="AddNewInstallerAuth0()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>

        <span class="SelectionRow" v-if="selectedAction == 'DeactInstaller'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span
                class="SelectionRow"
                v-if="selectedAction == 'DeactInstaller'"
              >
                <h3>Installer Removal Form</h3>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Name"
                      v-model="installerToDelete.name"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Username</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Username"
                      v-model="installerToDelete.nickname"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Company</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Username"
                      v-model="installerToDelete.company"
                      required
                      @focus="modal = false"
                    />
                  </b-col>

                  <b-col sm="3">
                    <p id="FormText">Status</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="UserName"
                      v-model="installerToDelete.status"
                      required
                      readonly
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <button
                      id="button"
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="InactivateInstaller()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>
      </div>

      <!--    <div>
      <b-row id="FormButtons">
        <b-col class="AdminTable">
            <ul v-on:click="showModal('NewLocation');" >
              Request New Location
            </ul>
        </b-col> 
        <b-col class="AdminTable">
            <ul v-on:click="showModal('RemoveLocation');" >
              Remove Location Access
            </ul>
        </b-col>
         
       
      </b-row> 
      </div> -->
      <div v-show="DivID === 'Add Client User'">
        <h3>Request User Add Form</h3>

        <b-row>
          <b-col sm="3">
            <p id="FormText">First Name</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="First Name"
              v-model="fName"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col sm="3">
            <p id="FormText">Last Name</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Last Name"
              v-model="lName"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <p id="FormText">Department</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Department"
              v-model="clDept"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col sm="3">
            <p id="FormText">Company</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Company"
              v-model="clCompany"
              required
              readonly
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <p id="FormText">Email Address</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Email Address"
              v-model="clEmail"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col sm="3">
            <p id="FormText">Location</p>
          </b-col>
          <b-col sm="3">
            <select v-model="clLocation">
              <option value="" select disabled>Select Location</option>
              <option
                v-for="(value, id) in this.locationsArray"
                :key="id"
                v-bind:value="{ id: value.id, text: value.location }"
                >{{ value.location }}</option
              >
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button
              id="button"
              class="button"
              @focus="modal = false"
              v-on:click="AddNewClientEmail()"
            >
              Submit
            </button>
            <button
              class="button"
              @focus="modal = false"
              v-on:click="resetForm()"
            >
              Clear
            </button>
          </b-col>
        </b-row>
      </div>

      <div v-show="DivID === 'EditLoc'">
        <h3>Edit Location Contact Info</h3>
        <b-row>
          <b-col sm="3">
            <p id="FormText">Address</p>
          </b-col>
          <b-col sm="3">
            <p id="FormText">{{ this.editLocAddress }}</p>
          </b-col>
          <b-col sm="3">
            <p id="FormText">Building Name</p>
          </b-col>
          <b-col sm="3">
            <p id="FormText">{{ this.editLocBuildingName }}</p>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="3">
            <p id="FormText">Area</p>
          </b-col>
          <b-col sm="3">
            <p id="FormText">{{ this.editLocArea }}</p>
          </b-col>
          <b-col sm="3">
            <p id="FormText">Escalation Name</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Escalation Name"
              v-model="editLocEscName"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="3">
            <p id="FormText">Escalation Telephone</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Escalation Phone No"
              v-model="editLocEscTele"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col sm="3">
            <p id="FormText">Escalation Email</p>
          </b-col>
          <b-col sm="3">
            <input
              type="text"
              placeholder="Escalation Email"
              v-model="editLocEscEmail"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>

        <button id="button" class="button" v-on:click="editLocation()">
          Submit
        </button>
        <button class="button" v-on:click="resetForm()">
          Clear
        </button>
      </div>
      <!-------------------------------------------------------------------------------------------------------------------- 
-->
      <b-modal
        ref="InstallerDeactivateModal"
        id="InstallerDeactivateModal"
        hide-footer
        title=" Installer Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Search by user's name</h3>
          <input
            maxlength="45"
            type="text"
            v-model="UserFirstNameSearch"
            placeholder="First Name"
          />
          <input
            maxlength="45"
            type="text"
            v-model="UserSurnameSearch"
            placeholder="Last Name"
          />
          <br />
          <button
            id="button"
            class="AdminButton"
            v-on:click="LookUpSubmit('InstallerDeactivate')"
          >
            Submit
          </button>
          <button class="AdminButton" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="InstallerSelectionModal"
        id="InstallerSelectionModal"
        hide-footer
        title=" Installer Selection Form"
        content-class="Modal"
      >
        <div>
          <h3>Select Client</h3>

          <select v-model="installerSelection">
            <option value="" select disabled>Select Installer</option>
            <option
              v-for="(value, id) in this.InstallerListArray"
              :key="id"
              v-bind:value="{
                urn: value.UserURN,
                name: value.Name,
                nickname: value.nickname,
                company: value.Company,
                status: value.Status,
              }"
              >{{ value.Name + " - " + value.nickname }}</option
            >
          </select>

          <br />
          <button
            id="button"
            class="AdminButton"
            v-on:click="installerSelect()"
          >
            Submit
          </button>
          <button class="AdminButton" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    btnCooldown: function() {
      let buttonid = "button";
      const button = document.querySelector("#" + buttonid + "");
      if (this.buttonCooldown == true) {
        const disableButton = () => {
          button.disabled = true;
        };
        button.addEventListener("click", disableButton);
      } else if (this.buttonCooldown == false) {
        button.disabled = false;
      }
    },

    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    resetForm() {
      this.DivID = "";
      (this.deactclURN = ""),
        (this.deactclFName = ""),
        (this.deactclLName = ""),
        (this.deactclDept = ""),
        (this.deactclLoc = ""),
        (this.fName = ""),
        (this.lName = "");
      this.clDept = "";
      this.clLocation = "";
      this.clEmail = "";
      this.DeviceRequestNo = "";
      this.messageforNewLocationEmail = "";
      this.selectedAction = "";
      this.insFName = "";
      this.insLName = "";
      this.insCompany = "";
      this.insPassword = "";
      this.nickname = "";
      this.UserFirstNameSearch = "";
      this.UserSurnameSearch = "";
      this.installerToDelete = "";
    },

    installerSelect() {
      this.hideModal("InstallerSelectionModal");
      this.installerToDelete = this.installerSelection;
      this.selectedAction = "DeactInstaller";
    },

    AddNewInstallerAuth0() {
      this.buttonCooldown = true;

      if (
        this.insPassword == "" ||
        this.insFName == "" ||
        this.insLName == ""
      ) {
        this.buttonCooldown = false;

        alert("Please ensure all fields are filled");
      } else if (/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(this.insPassword)) {
        this.insEmail = this.nickname + "@seraphprotectlogin.com";

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/auth0";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "CreateINS",
          Email: this.insEmail,
          UserMetaCompany: this.insCompany.text,
          UserMetaLocation: "",
          AppMetaAccess: "Installer",
          AppMetaPortal: "INS",
          FirstName: this.insFName,
          LastName: this.insLName,
          Name: this.insFName + " " + this.insLName,
          UserID: "",
          Password: this.insPassword,
          Username: this.nickname,
        };

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            this.buttonCooldown = false;

            this.insURN = response.data.Values.user_id;
            this.AddNewInstallerDB();
          });
      } else {
        this.buttonCooldown = false;

        alert(
          "Password needs to be a minimum of 8 characters, containing a lower case, upper case letter and a number."
        );
      }
    },

    AddNewInstallerDB() {
      this.buttonCooldown = true;

      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Create",
        Type: "INS",
        DataDict: [
          {
            UserURN: this.insURN,
            FirstName: this.insFName,
            LastName: this.insLName,
            Company: this.insCompany.text,
            Email: this.insEmail,
            Username: this.nickname,
          },
        ],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.HistoryNote = "Added Installer";
          alert("Installer has been created");
        });
    },

    InactivateInstaller() {
      this.buttonCooldown = true;

      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Delete",
        Type: "INS",
        DataDict: [{ UserURN: this.installerToDelete.urn }],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.HistoryNote = "Inactivated Installer";
          alert("Installer has been inactivated");
        });
    },

    HistorySubmit() {
      this.buttonCooldown = true;

      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };

      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
          this.buttonCooldown = false;
        });
    },

    LookUpSubmit: function(Lookup) {
      this.buttonCooldown = true;

      if (Lookup === "InstallerDeactivate") {
        let LookUpURLINS =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/sulookups";
        let LookUpHeadersINS = this.$apikeyPost;
        let LookUpRequestINS = {
          RequestType: "Installer",
          RequestVariable: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
        };

        axios
          .post(LookUpURLINS, LookUpRequestINS, LookUpHeadersINS)
          .then((response) => {
            this.buttonCooldown = false;

            if (response.data.Values == "Invalid Name") {
              this.buttonCooldown = false;

              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.InstallerList = "";
              this.InstallerList = response.data.Values;
              this.installerSelection = [];
              this.installerToDelete = {};
              this.installerSelection.push({
                urn: this.InstallerList[0][0],
                name: this.InstallerList[0][1],
                nickname: this.InstallerList[0][2],
                company: this.InstallerList[0][3],
                status: this.InstallerList[0][4],
              });
              this.installerToDelete = this.installerSelection[0];
              /*  this.deactInsURN = response.data.Values[0][0]
          this.deactInsFName = response.data.Values[0][1]
          this.deactInsLName = response.data.Values[0][2]
          this.deactInsEmail = response.data.Values[0][3]
          this.deactInsStatus = response.data.Values[0][5] */
              this.hideModal("InstallerDeactivateModal");
              this.selectedAction = "DeactInstaller";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.InstallerList = "";
              this.InstallerList = response.data.Values;
              for (let i = 0; i < this.InstallerList.length; i++) {
                var QuoteStr1 = this.InstallerList[i][0];
                this.InstallerListArray.push({
                  UserURN: QuoteStr1,
                  Name: this.InstallerList[i][1],
                  nickname: this.InstallerList[i][2],
                  Company: this.InstallerList[i][3],
                  Status: this.InstallerList[i][4],
                });
              }
              this.hideModal("InstallerDeactivateModal");
              this.showModal("InstallerSelectionModal");
            }
          });
      }
    },

    /* UserNAME GENERATION DO NOT DELETE */

    generateUserName: function() {
      var randomNo1 = Math.floor(Math.random() * 9);
      var randomNo2 = Math.floor(Math.random() * 9);
      var randomNo3 = Math.floor(Math.random() * 9);
      var randomNo4 = Math.floor(Math.random() * 9);

      let totalNo = randomNo1.toString(10);
      totalNo = totalNo + randomNo2.toString(10);
      totalNo = totalNo + randomNo3.toString(10);
      totalNo = totalNo + randomNo4.toString(10);

      this.nickname = "";
      this.nickname = this.insFName.slice(0, 3) + this.insLName.slice(0, 3);
      this.nickname = this.nickname + totalNo;
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
  },

  mounted() {
    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }
    /* Company Lookup */
    let LookUpUrlCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersCompany = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Company" };
    axios
      .post(LookUpUrlCompany, this.LookUpRequest, LookUpHeadersCompany)
      .then((response) => {
        this.companylist = response.data.Values;
        for (let i = 0; i < this.companylist.length; i++) {
          var QuoteStr4 = this.companylist[i][0];
          this.companyArray.push({
            id: QuoteStr4,
            name: this.companylist[i][1],
          });
        }
      });

    /* Pre Existing Look Ups, Remove at some point */

    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest3 = { RequestType: "BMULocation", UserURN: this.UserURN };
    axios
      .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
      .then((response) => {
        this.locationslist = response.data.Values;
        for (let i = 0; i < this.locationslist.length; i++) {
          var QuoteStr4 = this.locationslist[i][0];
          this.locationsArray.push({
            id: QuoteStr4,
            location: this.locationslist[i][2],
            address: this.locationslist[i][1],
          });
        }
      });

    let LookUpUrlLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeadersLocation = this.$apikeyPost;
    this.LookUpRequestLocation = {
      RequestType: "BMULocation",
      UserURN: this.UserURN,
    };
    axios
      .post(
        LookUpUrlLocation,
        this.LookUpRequestLocation,
        LookUpHeadersLocation
      )
      .then((response) => {
        this.locations = response.data.Values;
      });
    let LookUpUrlCountry =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersCountry = this.$apikeyPost;
    let LookUpRequestCountry = { RequestType: "CountryAll" };
    axios
      .post(LookUpUrlCountry, LookUpRequestCountry, LookUpHeadersCountry)
      .then((response) => {
        response;
        this.CountriesList = response.data.Values;
        for (let i = 0; i < this.CountriesList.length; i++) {
          var QuoteStr4 = this.CountriesList[i][0];
          this.CountriesArray.push({
            id: QuoteStr4,
            Country: this.CountriesList[i][1],
          });
        }
      });

    let LookUpUrlRegion =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersRegion = this.$apikeyPost;
    let LookUpRequestRegion = {
      RequestType: "RegionByCountry",
      CountryID: "5",
    };
    axios
      .post(LookUpUrlRegion, LookUpRequestRegion, LookUpHeadersRegion)
      .then((response) => {
        response;
        this.RegionsList = response.data.Values;
        for (let i = 0; i < this.RegionsList.length; i++) {
          var QuoteStr4 = this.RegionsList[i][0];
          this.RegionsArray.push({
            id: QuoteStr4,
            Region: this.RegionsList[i][1],
          });
        }
      });
  },

  data() {
    return {
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: this.$Company,
      clDept: "",
      clLocation: "",
      clEmail: "",
      clURN: "",
      UserFirstNameSearch: "",
      UserSurnameSearch: "",
      deactclURN: "",
      deactclFName: "",
      deactclLName: "",
      deactclDept: "",
      deactclLoc: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      contactLocation: this.$Location,
      DeviceRequestNo: "",
      userName: this.$FullName,
      BMULocationRemove: "",
      UserURN: this.$UserURN,
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      messageforNewLocationEmail: "",
      selectedSearch: "",
      UserProfile: this.$ProfilePortal,
      selectedAction: "",

      companyArray: [],
      companyList: [],
      insPassword: "",
      nickname: "",
      insLName: "",
      insFName: "",
      insCompany: "",
      insEmail: "",

      InstallerListArray: [],
      InstallerList: [],

      installerSelection: "",

      deactInsURN: "",
      installerToDelete: "",
      buttonCooldown: false,
    };
  },

  watch: {
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 100%;
  padding: 7px 7px 7px 7px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 15px;
  background-color: rgb(245, 245, 245);
}

div {
  float: left;
  width: 100%;
  padding: 10px;
}

.container-fluid {
  border-style: none;
}

.card-body {
  border-style: none;
}

.collapse.show {
  border-style: none;
}

.container {
  border-style: none;
}

.row {
  border-style: none;
}
li {
  width: 100%;
}
input {
  margin-bottom: 8px;
}

input[type="number" i] {
  width: 30%;
}

.Auto {
  border: none;
  padding: none;
  margin: none;
}
.AutoDrop {
  width: 130%;
  text-align: left;
  float: right;
}

.locationAutoFill {
  border: none;
  padding: none;
  margin: none;
}

.locationAutoFillSpan {
  border: none;
  width: 50%;
  margin-left: 29%;
}

.locationAutoFillSpan li {
  background-color: whitesmoke;
}

.HandwashLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

.LocationHandwashAutoFillSpan {
  border: none;
  padding-left: 30%;
}

.LocationHandwashAutoFillSpan ul {
  width: 35%;
}

#AGPortalUser {
  margin-left: 10px;
}

.AutoDropDown {
  border: none;
  margin: none;
  padding: none;
}

.EditLocationAutoFillSpan {
  border: none;
}
.EditLocationAutoFillSpan ul {
  border: none;
  margin-left: 1%;
}

.EditLocationAutoFillSpan li {
  background: white;
}

.EditLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

#StaffRoleHide {
  border: none;
}
#LocationHide {
  border: none;
}

#DropdownAGRFIDRole {
  margin-left: 6px;
}

.lightText {
  text-align: center;
}

.LocationUnitAutoFillSpan {
  border: none;
}
.LocationUnitAutoFillSpan ul {
  border: none;
  margin-left: 10%;
}

.LocationUnitAutoFillSpan li {
  background: white;
}
.LocationDropdown {
  border: none;
}

#SubmitButtons {
  border: none;
  text-align: center;
}
.EditLocationDropdown input {
  margin-left: -5px;
}

#CenterButtons {
  text-align: center;
  border: none;
  padding: none;
  margin: none;
}

.tablinksActive {
  width: 25%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 25%;
}

div.tab,
div.tabBottom {
  padding: 0;
}

.tablinksClientAdminActive {
  width: 50%;
}

.tablinksClientAdmin {
  width: 50%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

div.tabcontent {
  padding: 0;
}

.tablinksDeviceAdminActive {
  width: 25%;
}

.tablinksDeviceAdmin {
  width: 25%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 50%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 50%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 50%;
}

.reportTabActive {
  width: 50%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}
.AdminButton:hover {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
.AdminButton {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
</style>
